import { render, staticRenderFns } from "./DailyBoxCreate.vue?vue&type=template&id=1862a234&scoped=true"
import script from "./DailyBoxCreate.vue?vue&type=script&lang=js"
export * from "./DailyBoxCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1862a234",
  null
  
)

export default component.exports